<template>
  <section v-loading="loading" class="attachment-popup-body">
    <div class="attachment-upload-button">
      <el-upload
        name="logo"
        action
        :on-change="uploadFile"
        :show-file-list="false"
        :auto-upload="false"
      >
        <el-button
          class="btn radius-button round-button"
          v-if="!isCaseCompleted"
        >
          <span>
            <img
              src="@/assets/images/icons/attachment-icon-v2.svg"
              alt=""
            /> </span
          >SELECT FILE</el-button
        >
      </el-upload>
    </div>

    <!-- Attachment upload -->
    <div class="attachment-upload">
      <a
        v-if="selectedFileName"
        v-loading="fileUploadLoading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div class="content">
          <div class="icon">
            <img
              src="@/assets/images/icons/attachments/attachments_0.svg"
              alt="icon"
              class="img-fluid"
            />
          </div>
          <div class="text">
            <p>
              {{ selectedFileName }}
            </p>
          </div>
        </div>
        <ul class="actions">
          <li>
            <el-button @click="remove" class="remove-button">
              <el-icon><close /></el-icon>
            </el-button>
          </li>
          <li>
            <el-button
              class="upload-button"
              @click="uploadSelectedDocument"
              :disabled="!selectedFile ? true : false"
            >
              <el-icon><Upload /></el-icon>
            </el-button>
          </li>
        </ul>
      </a>
    </div>

    <!-- Attachment uploaded -->
    <div v-if="!noDocuments" class="attachment-uploaded">
      <ul>
        <li v-for="(doc, index) of allInternalDocuments" :key="index">
          <div class="content" @click="downloadDocument(doc)">
            <div class="icon">
              <img
                src="@/assets/images/icons/attachments/attachments_0.svg"
                alt="icon"
                class="img-fluid"
              />
            </div>
            <p class="text">
              {{ doc.metadata.original_name }}
            </p>
          </div>
          <button
            class="remove-button"
            type="button"
            @click="onDeleteAttachment(doc)"
          >
            <p>Remove</p>
          </button>
        </li>
      </ul>
    </div>

    <div class="attachments-empty" v-if="noDocuments && !this.selectedFileName">
      <p>
        You can manage Internal documents <br />
        here, please add to start
      </p>
    </div>
    <div class="mini-reason-for-change">
      <ResonForChange
        v-if="takeReasonForChangeDialog"
        v-on:close="takeReasonForChangeDialog = false"
        v-on:reasonSubmit="onTakeAction"
        title="Reason for Remove"
      ></ResonForChange>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
const ResonForChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
import { defineAsyncComponent } from "vue";
import axios from "axios";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  name: "InternalDocuments",
  components: {
    ResonForChange,
  },
  computed: {
    ...mapGetters("pendingCases", [
      "getFileUploadURLForAttachments",
      "getFileUploadRefIdForAttachment",
      "getAttachmentUploadStatusUpdated",
      "getAttachmentUploadStatus",
      "getAttachmentDeleteStatus",
      "getsinglePatientDetails",
    ]),
    ...mapGetters("respiratoryFileUpload", ["getFileDownloadUrl"]),
    isCaseCompleted() {
      if (!this.getsinglePatientDetails) {
        return false;
      }
      return (
        this.getsinglePatientDetails.status === "COMPLETE" ||
        this.getsinglePatientDetails.status === "REJECTED"
      );
    },
  },

  mounted() {
    this.checkCaseInformation();
  },
  data() {
    return {
      noDocuments: false,
      selectedFile: null,
      selectedFileName: null,
      caseId: "",
      allInternalDocuments: [],
      loadingText: "",
      loading: false,
      fileUploadLoading: false,
      takeReasonForChangeDialog: false,
      selectedNote: null,
    };
  },
  methods: {
    onDeleteAttachment(doc) {
      this.takeReasonForChangeDialog = true;
      this.selectedNote = doc;
    },
    onTakeAction(reason) {
      this.deleteAttachment(reason);
    },

    uploadFile(file) {
      this.selectedFile = file.raw;
      this.selectedFileName = file.raw.name;
      this.getFileUploadUrl(file);
    },
    remove() {
      this.selectedFile = null;
      this.selectedFileName = "";
    },
    async getFileUploadUrl(file) {
      try {
        this.loading = true;
        let data = {
          file: file.raw.name,
          file_type: file.raw.type,
          file_size: file.raw.size / 1000,
          pending_case_id: this.caseId,
          type: "case-internal-documents-upload",
        };
        await this.$store.dispatch("pendingCases/fetchDocumentUploadUrl", data);
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    async uploadSelectedDocument() {
      this.fileUploadLoading = true;
      this.loadingText = "Uploading Document...";
      // uploding to S3
      let params = {
        file: this.selectedFile,
        upload_url: this.getFileUploadURLForAttachments,
      };

      await this.$store.dispatch(
        "pendingCases/uploadDocumentToGeneratedUrl",
        params
      );

      if (this.getAttachmentUploadStatus) {
        // UPDATEING STATUS
        let params = {
          hash: this.getFileUploadRefIdForAttachment,
          pending_case_id: this.caseId,
          type: "case-internal-documents-upload",
        };
        await this.$store.dispatch(
          "pendingCases/updateDocumentUploadStatus",
          params
        );
        if (this.getAttachmentUploadStatusUpdated) {
          successNotification("Internal Document added successfully");
          this.selectedFileName = "";
          this.selectedFile = null;
          this.checkCaseInformation();
        } else {
          this.$message("Sorry ! Error while file uploading");
        }
      } else {
        this.$message("Sorry ! Error while file uploading");
      }
      this.fileUploadLoading = false;
    },

    async deleteAttachment(reason) {
      let params = {
        case_id: this.caseId,
        id: this.selectedNote._id,
        data_update_reason: reason,
      };

      await this.$store.dispatch("pendingCases/deleteInternalDocument", params);

      if (this.getAttachmentDeleteStatus) {
        successNotification("Internal Document deleted successfully");
        this.checkCaseInformation();
      }
    },

    async downloadDocument(doc) {
      await this.$store.dispatch("respiratoryFileUpload/fetchFileDownloadUrl", {
        path: "case_internal_documents/" + doc.path,
      });

      let url = this.getFileDownloadUrl.download_url;
      axios({
        url: url, //your url
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const href = URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", `${doc.path}`); //or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      });
    },

    async checkCaseInformation() {
      this.loading = true;
      this.fileUploadLoading = false;
      this.caseId = this.$route.params.case_id;
      if (!this.caseId) {
        this.loading = false;
        this.$router.push({
          to: "/pendingCases",
        });
      } else {
        await this.$store.dispatch("pendingCases/fetchSingleCaseInformation", {
          case_id: this.caseId,
        });
        if (!this.getsinglePatientDetails) {
          this.disablePatientInformation = true;
        }
        if (
          this.getsinglePatientDetails &&
          this.getsinglePatientDetails.internal_documents
        ) {
          this.allInternalDocuments =
            this.getsinglePatientDetails.internal_documents || [];
          this.allInternalDocuments = this.allInternalDocuments.sort(
            (a, b) => moment(b.created_at) - moment(a.created_at)
          );
          this.noDocuments = this.allInternalDocuments.length ? false : true;
        }
      }
      this.loading = false;
    },
  },
};
</script>
